export var symptomatology = {
    name: "Symptomatology",
    id: "symptomatology",
    depth: 2,
    enableToInclueOtherTagToTopLevel: false,
    tags: [
        {
            name: "Abnormalities of perception",
            id: "Aj82WV",
            children: [
                {
                    name: "Hypersensitivity to sensory stimuli",
                    id: "We5rbM",
                },
                {
                    name: "Hypo-sensitivity",
                    id: "Sh4iqT",
                },
                {
                    name: "Altered perception",
                    id: "qQ4U6L",
                },
                {
                    name: "Auditory hallucination",
                    id: "Q3jKdE",
                },
                {
                    name: "Visual hallucination",
                    id: "u5MgCA",
                },
                {
                    name: "Thought hearing",
                    id: "Ep43mr",
                },
                {
                    name: "Cenesthopathy",
                    id: "K6vjP5",
                },
            ],
        },
        {
            name: "Abnormalities of thought",
            id: "hA8vGe",
            children: [
                {
                    name: "Inhibition of thought",
                    id: "K2vXAF",
                },
                {
                    name: "Flight of idea",
                    id: "wZ3y7L",
                },
                {
                    name: "Blocking of thought",
                    id: "w3FhdD",
                },
                {
                    name: "Loosening of association",
                    id: "Rn34G2",
                },
                {
                    name: "Automatic thought",
                    id: "p8YxQW",
                },
                {
                    name: "Thought insertion",
                    id: "B5pVuw",
                },
                {
                    name: "Thoughts being read",
                    id: "Sm5kng",
                },
                {
                    name: "Thought broadcasting",
                    id: "Rx9t5N",
                },
                {
                    name: "Obsessive thought",
                    id: "K2s4ZX",
                },
                {
                    name: "Delusion",
                    id: "eR2g9w",
                },
            ],
        },
        {
            name: "Disturbance of self",
            id: "b9VRvm",
            children: [
                {
                    name: "Depersonalization",
                    id: "wV7mCU",
                },
                {
                    name: "Delusion of control",
                    id: "xM84cd",
                },
                {
                    name: "Dissociation",
                    id: "Lp7E5x",
                },
                {
                    name: "Spirit possession",
                    id: "vJ9acx",
                },
                {
                    name: "Passivity symptoms",
                    id: "Rb7Yf8",
                },
            ],
        },
        {
            name: "Disorder of emotion",
            id: "kR8d29",
            children: [
                {
                    name: "Hyperthymia",
                    id: "F7yvmk",
                },
                {
                    name: "Depressive mood",
                    id: "Hd7LgP",
                },
                {
                    name: "Anxiety",
                    id: "T7gHYp",
                },
                {
                    name: "Panic attack",
                    id: "w7Pxny",
                },
                {
                    name: "Dysthymia",
                    id: "N8hDzg",
                },
                {
                    name: "Affective labile",
                    id: "dN5Q9X",
                },
                {
                    name: "Irritability",
                    id: "X6jWBr",
                },
                {
                    name: "Anhedonia",
                    id: "Zv8MP2",
                },
                {
                    name: "Alexithymia",
                    id: "iJ9nuC",
                },
            ],
        },
        {
            name: "Impaired intention/volition",
            id: "kN4ZQJ",
            children: [
                {
                    name: "Psychomotor excitation",
                    id: "K4jMuY",
                },
                {
                    name: "Psychomotor inhibition",
                    id: "z6LTat",
                },
                {
                    name: "Stupor",
                    id: "Gc2qdz",
                },
                {
                    name: "Avolition",
                    id: "C4d5wa",
                },
                {
                    name: "Bradyphrenia",
                    id: "s8Uyjr",
                },
                {
                    name: "Abulia",
                    id: "Bw5XdV",
                },
                {
                    name: "Dissociation",
                    id: "zB6ErM",
                },
            ],
        },
        {
            name: "Others",
            id: "Cc7GEt",
            children: [
                {
                    name: "Cognitive process",
                    id: "pN6h3s",
                },
                {
                    name: "Unspecified",
                    id: "V2vDaR",
                },
            ],
        },
    ],
};
